import api from 'api';

export const loadSystemMessages = api('GET /api/common/system-messages'); //TODO: set req

// export const closeSystemMessage = api('POST /api/news-list'); //TODO: set req
export const closeSystemMessage = api(
  'POST /api/common/system-messages/:id/mark-as-read'
);
